var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "error_404"
  }, [_c('div', {
    staticClass: "container-scroller"
  }, [_c('div', {
    staticClass: "container-fluid page-body-wrapper full-page-wrapper"
  }, [_c('div', {
    staticClass: "\n          content-wrapper\n          d-flex\n          align-items-center\n          text-center\n          error-page\n          bg-primary\n        "
  }, [_c('div', {
    staticClass: "row flex-grow"
  }, [_c('div', {
    staticClass: "col-lg-7 mx-auto text-white"
  }, [_c('div', {
    staticClass: "row align-items-center d-flex flex-row"
  }, [_c('div', {
    staticClass: "col-lg-6 text-lg-right pr-lg-4"
  }, [_c('h1', {
    staticClass: "display-1 mb-0"
  }, [_vm._v("Oops")])]), _c('div', {
    staticClass: "col-lg-6 error-page-divider text-lg-left pl-lg-4"
  }, [_c('h3', {
    staticClass: "font-weight-light"
  }, [_vm._v(" 目前此功能尚未啟用"), _c('br'), _vm._v(" This module is not available. ")])])]), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 text-center mt-xl-2"
  })]), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 mt-xl-2"
  }, [_c('p', {
    staticClass: "text-white font-weight-medium text-center"
  }, [_vm._v(" Copyright © 2023 Waltily All rights reserved. ")])])])])])])])])]);
}]

export { render, staticRenderFns }